import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-triangle-sharp",
  "use": "icon-triangle-sharp-usage",
  "viewBox": "0 0 512 512",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" class=\"ionicon\" viewBox=\"0 0 512 512\" id=\"icon-triangle-sharp\"><title>Triangle</title><path d=\"M256 32L20 464h472L256 32z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol